import {DocumentPartTemplateData} from '@dv5/domain'
import React, {FC} from 'react'
import {ViewMode} from './useTemplateDataEditor'

interface Props {
    initialFormData: DocumentPartTemplateData
    formPartHeader: string
    formPartContent: string
    onHeaderChange: (value: string) => void
    onContentChange: (value: string) => void
    viewMode: ViewMode
}

export const DocumentPartTemplateContent: FC<Props> = ({
    initialFormData,
    formPartHeader,
    formPartContent,
    onHeaderChange,
    onContentChange,
    viewMode,
}) => {
    if (viewMode === 'formEdit') {
        return (
            <div className="template-data-form">
                <div className="template-data-form-field">
                    <label className="template-data-form-label">Type</label>
                    <div className="template-data-form-value">{initialFormData.partType}</div>
                </div>
                <div className="template-data-form-field">
                    <label className="template-data-form-label">Header</label>
                    <input
                        type="text"
                        className="template-data-form-input"
                        value={formPartHeader}
                        onChange={(e) => onHeaderChange(e.target.value)}
                    />
                </div>
                <div className="template-data-form-field template-data-form-field-content">
                    <label className="template-data-form-label">Content</label>
                    <textarea
                        className="template-data-form-textarea"
                        value={formPartContent}
                        onChange={(e) => onContentChange(e.target.value)}
                        spellCheck={false}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="template-data-form">
            <div className="template-data-form-field">
                <label className="template-data-form-label">Type</label>
                <div className="template-data-form-value">{initialFormData.partType}</div>
            </div>
            <div className="template-data-form-field">
                <label className="template-data-form-label">Header</label>
                <div className="template-data-form-value">{initialFormData.partHeader}</div>
            </div>
            <div className="template-data-form-field template-data-form-field-content">
                <label className="template-data-form-label">Content</label>
                <div className="template-data-form-value template-data-form-value-multiline">{initialFormData.partContent}</div>
            </div>
        </div>
    )
}
